/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  TravellerType,
  travellerTypeToNumber,
  travellerTypeFromJSON,
  travellerTypeToJSON,
} from "../TravellerType";
import { DiscountInformation } from "./DiscountInformation";
import {
  RedeemType,
  VoucherType,
  redeemTypeToNumber,
  redeemTypeFromJSON,
  redeemTypeToJSON,
  voucherTypeToNumber,
  voucherTypeFromJSON,
  voucherTypeToJSON,
} from "../Voucher";

export interface TravellerPrice {
  age: number;
  amount: number;
  type: TravellerType;
}

export interface TravellerSummary {
  /** the amount of travellers of the corresponding type within the room */
  amount: number;
  /** the aggregated price amount of travellers of the corresponding type within the room */
  price: number;
  /** the list of child ages (only used for children summary) */
  ages: number[];
}

export interface RoomSummary {
  /** the adult summary */
  adults?: TravellerSummary;
  /** the children summary */
  children?: TravellerSummary;
  /** the infant summary */
  infants?: TravellerSummary;
  /** the total room price */
  roomPrice: number;
}

export interface RoomPrice {
  isAnnexBuilding: boolean;
  label: string;
  summary?: RoomSummary;
  travellerPriceList: TravellerPrice[];
}

export interface PackagePrice {
  adultCount: number;
  childCount: number;
  infantCount: number;
  amount: number;
  discountInformation?: DiscountInformation;
  roomPriceList: RoomPrice[];
}

export interface TourOperatorVoucherComponent {
  amount: number;
  tourOperator: string;
  description: string;
  validUntil: string;
  redeemType: RedeemType;
}

export interface TravelPrice {
  amount: number;
  ancillariesPrice: number;
  refundableCancellationFee: number;
  packagePrice?: PackagePrice;
  tourOperatorVoucher?: TourOperatorVoucherComponent;
}

export interface TotalPrice {
  amount: number;
  perPerson: number;
  notRefundableCancellationFee: number;
  insurancePrice: number;
  transferPrice: number;
  travelPrice?: TravelPrice;
}

export interface CompensationVoucherComponent {
  count: number;
  amount: number;
  tourOperator: string;
}

export interface UnknownVoucherComponent {
  count: number;
  tourOperator: string;
}

export interface PaidPrice {
  amount: number;
  totalPrice?: TotalPrice;
  /** @deprecated */
  compensationVoucher?: CompensationVoucherComponent;
  unknownVoucher?: UnknownVoucherComponent;
}

export interface C24VoucherComponent {
  isWebsitePromo: boolean;
  amount: number;
  type: VoucherType;
}

export interface LoyaltyPointsCashback {
  isRelevant: boolean;
  redeemablePoints: number;
  amount: number;
}

export interface EffectivePrice {
  showEffectivePrice: boolean;
  hasAmountDiff: boolean;
  amount: number;
  cashback: number;
  cashbackType: EffectivePrice_CashbackType;
  paidPrice?: PaidPrice;
  c24Voucher?: C24VoucherComponent;
  tourOperatorVoucher?: TourOperatorVoucherComponent;
  loyaltyPointsCashback?: LoyaltyPointsCashback;
}

export enum EffectivePrice_CashbackType {
  None = "None",
  C24Voucher = "C24Voucher",
  LoyaltyPoints = "LoyaltyPoints",
  C24AndLoyalty = "C24AndLoyalty",
}

export function effectivePrice_CashbackTypeFromJSON(
  object: any
): EffectivePrice_CashbackType {
  switch (object) {
    case 0:
    case "None":
      return EffectivePrice_CashbackType.None;
    case 1:
    case "C24Voucher":
      return EffectivePrice_CashbackType.C24Voucher;
    case 2:
    case "LoyaltyPoints":
      return EffectivePrice_CashbackType.LoyaltyPoints;
    case 3:
    case "C24AndLoyalty":
      return EffectivePrice_CashbackType.C24AndLoyalty;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum EffectivePrice_CashbackType"
      );
  }
}

export function effectivePrice_CashbackTypeToJSON(
  object: EffectivePrice_CashbackType
): string {
  switch (object) {
    case EffectivePrice_CashbackType.None:
      return "None";
    case EffectivePrice_CashbackType.C24Voucher:
      return "C24Voucher";
    case EffectivePrice_CashbackType.LoyaltyPoints:
      return "LoyaltyPoints";
    case EffectivePrice_CashbackType.C24AndLoyalty:
      return "C24AndLoyalty";
    default:
      return "UNKNOWN";
  }
}

export function effectivePrice_CashbackTypeToNumber(
  object: EffectivePrice_CashbackType
): number {
  switch (object) {
    case EffectivePrice_CashbackType.None:
      return 0;
    case EffectivePrice_CashbackType.C24Voucher:
      return 1;
    case EffectivePrice_CashbackType.LoyaltyPoints:
      return 2;
    case EffectivePrice_CashbackType.C24AndLoyalty:
      return 3;
    default:
      return 0;
  }
}

function createBaseTravellerPrice(): TravellerPrice {
  return { age: 0, amount: 0, type: TravellerType.TravellerTypeUnknown };
}

export const TravellerPrice = {
  encode(
    message: TravellerPrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.age !== 0) {
      writer.uint32(24).uint32(message.age);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.type !== TravellerType.TravellerTypeUnknown) {
      writer.uint32(16).int32(travellerTypeToNumber(message.type));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TravellerPrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTravellerPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.age = reader.uint32();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 2:
          message.type = travellerTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TravellerPrice {
    return {
      age: isSet(object.age) ? Number(object.age) : 0,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      type: isSet(object.type)
        ? travellerTypeFromJSON(object.type)
        : TravellerType.TravellerTypeUnknown,
    };
  },

  toJSON(message: TravellerPrice): unknown {
    const obj: any = {};
    message.age !== undefined && (obj.age = Math.round(message.age));
    message.amount !== undefined && (obj.amount = message.amount);
    message.type !== undefined &&
      (obj.type = travellerTypeToJSON(message.type));
    return obj;
  },

  fromPartial(object: DeepPartial<TravellerPrice>): TravellerPrice {
    const message = createBaseTravellerPrice();
    message.age = object.age ?? 0;
    message.amount = object.amount ?? 0;
    message.type = object.type ?? TravellerType.TravellerTypeUnknown;
    return message;
  },
};

function createBaseTravellerSummary(): TravellerSummary {
  return { amount: 0, price: 0, ages: [] };
}

export const TravellerSummary = {
  encode(
    message: TravellerSummary,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(8).uint32(message.amount);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    writer.uint32(26).fork();
    for (const v of message.ages) {
      writer.uint32(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TravellerSummary {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTravellerSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.uint32();
          break;
        case 2:
          message.price = reader.float();
          break;
        case 3:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ages.push(reader.uint32());
            }
          } else {
            message.ages.push(reader.uint32());
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TravellerSummary {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      ages: Array.isArray(object?.ages)
        ? object.ages.map((e: any) => Number(e))
        : [],
    };
  },

  toJSON(message: TravellerSummary): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = Math.round(message.amount));
    message.price !== undefined && (obj.price = message.price);
    if (message.ages) {
      obj.ages = message.ages.map((e) => Math.round(e));
    } else {
      obj.ages = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<TravellerSummary>): TravellerSummary {
    const message = createBaseTravellerSummary();
    message.amount = object.amount ?? 0;
    message.price = object.price ?? 0;
    message.ages = object.ages?.map((e) => e) || [];
    return message;
  },
};

function createBaseRoomSummary(): RoomSummary {
  return {
    adults: undefined,
    children: undefined,
    infants: undefined,
    roomPrice: 0,
  };
}

export const RoomSummary = {
  encode(
    message: RoomSummary,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.adults !== undefined) {
      TravellerSummary.encode(
        message.adults,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.children !== undefined) {
      TravellerSummary.encode(
        message.children,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.infants !== undefined) {
      TravellerSummary.encode(
        message.infants,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.roomPrice !== 0) {
      writer.uint32(37).float(message.roomPrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RoomSummary {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.adults = TravellerSummary.decode(reader, reader.uint32());
          break;
        case 2:
          message.children = TravellerSummary.decode(reader, reader.uint32());
          break;
        case 3:
          message.infants = TravellerSummary.decode(reader, reader.uint32());
          break;
        case 4:
          message.roomPrice = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RoomSummary {
    return {
      adults: isSet(object.adults)
        ? TravellerSummary.fromJSON(object.adults)
        : undefined,
      children: isSet(object.children)
        ? TravellerSummary.fromJSON(object.children)
        : undefined,
      infants: isSet(object.infants)
        ? TravellerSummary.fromJSON(object.infants)
        : undefined,
      roomPrice: isSet(object.roomPrice) ? Number(object.roomPrice) : 0,
    };
  },

  toJSON(message: RoomSummary): unknown {
    const obj: any = {};
    message.adults !== undefined &&
      (obj.adults = message.adults
        ? TravellerSummary.toJSON(message.adults)
        : undefined);
    message.children !== undefined &&
      (obj.children = message.children
        ? TravellerSummary.toJSON(message.children)
        : undefined);
    message.infants !== undefined &&
      (obj.infants = message.infants
        ? TravellerSummary.toJSON(message.infants)
        : undefined);
    message.roomPrice !== undefined && (obj.roomPrice = message.roomPrice);
    return obj;
  },

  fromPartial(object: DeepPartial<RoomSummary>): RoomSummary {
    const message = createBaseRoomSummary();
    message.adults =
      object.adults !== undefined && object.adults !== null
        ? TravellerSummary.fromPartial(object.adults)
        : undefined;
    message.children =
      object.children !== undefined && object.children !== null
        ? TravellerSummary.fromPartial(object.children)
        : undefined;
    message.infants =
      object.infants !== undefined && object.infants !== null
        ? TravellerSummary.fromPartial(object.infants)
        : undefined;
    message.roomPrice = object.roomPrice ?? 0;
    return message;
  },
};

function createBaseRoomPrice(): RoomPrice {
  return {
    isAnnexBuilding: false,
    label: "",
    summary: undefined,
    travellerPriceList: [],
  };
}

export const RoomPrice = {
  encode(
    message: RoomPrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isAnnexBuilding === true) {
      writer.uint32(32).bool(message.isAnnexBuilding);
    }
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.summary !== undefined) {
      RoomSummary.encode(message.summary, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.travellerPriceList) {
      TravellerPrice.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RoomPrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.isAnnexBuilding = reader.bool();
          break;
        case 1:
          message.label = reader.string();
          break;
        case 3:
          message.summary = RoomSummary.decode(reader, reader.uint32());
          break;
        case 2:
          message.travellerPriceList.push(
            TravellerPrice.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RoomPrice {
    return {
      isAnnexBuilding: isSet(object.isAnnexBuilding)
        ? Boolean(object.isAnnexBuilding)
        : false,
      label: isSet(object.label) ? String(object.label) : "",
      summary: isSet(object.summary)
        ? RoomSummary.fromJSON(object.summary)
        : undefined,
      travellerPriceList: Array.isArray(object?.travellerPriceList)
        ? object.travellerPriceList.map((e: any) => TravellerPrice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RoomPrice): unknown {
    const obj: any = {};
    message.isAnnexBuilding !== undefined &&
      (obj.isAnnexBuilding = message.isAnnexBuilding);
    message.label !== undefined && (obj.label = message.label);
    message.summary !== undefined &&
      (obj.summary = message.summary
        ? RoomSummary.toJSON(message.summary)
        : undefined);
    if (message.travellerPriceList) {
      obj.travellerPriceList = message.travellerPriceList.map((e) =>
        e ? TravellerPrice.toJSON(e) : undefined
      );
    } else {
      obj.travellerPriceList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<RoomPrice>): RoomPrice {
    const message = createBaseRoomPrice();
    message.isAnnexBuilding = object.isAnnexBuilding ?? false;
    message.label = object.label ?? "";
    message.summary =
      object.summary !== undefined && object.summary !== null
        ? RoomSummary.fromPartial(object.summary)
        : undefined;
    message.travellerPriceList =
      object.travellerPriceList?.map((e) => TravellerPrice.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBasePackagePrice(): PackagePrice {
  return {
    adultCount: 0,
    childCount: 0,
    infantCount: 0,
    amount: 0,
    discountInformation: undefined,
    roomPriceList: [],
  };
}

export const PackagePrice = {
  encode(
    message: PackagePrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.adultCount !== 0) {
      writer.uint32(24).uint32(message.adultCount);
    }
    if (message.childCount !== 0) {
      writer.uint32(32).uint32(message.childCount);
    }
    if (message.infantCount !== 0) {
      writer.uint32(40).uint32(message.infantCount);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.discountInformation !== undefined) {
      DiscountInformation.encode(
        message.discountInformation,
        writer.uint32(50).fork()
      ).ldelim();
    }
    for (const v of message.roomPriceList) {
      RoomPrice.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PackagePrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePackagePrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.adultCount = reader.uint32();
          break;
        case 4:
          message.childCount = reader.uint32();
          break;
        case 5:
          message.infantCount = reader.uint32();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 6:
          message.discountInformation = DiscountInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.roomPriceList.push(RoomPrice.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PackagePrice {
    return {
      adultCount: isSet(object.adultCount) ? Number(object.adultCount) : 0,
      childCount: isSet(object.childCount) ? Number(object.childCount) : 0,
      infantCount: isSet(object.infantCount) ? Number(object.infantCount) : 0,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      discountInformation: isSet(object.discountInformation)
        ? DiscountInformation.fromJSON(object.discountInformation)
        : undefined,
      roomPriceList: Array.isArray(object?.roomPriceList)
        ? object.roomPriceList.map((e: any) => RoomPrice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PackagePrice): unknown {
    const obj: any = {};
    message.adultCount !== undefined &&
      (obj.adultCount = Math.round(message.adultCount));
    message.childCount !== undefined &&
      (obj.childCount = Math.round(message.childCount));
    message.infantCount !== undefined &&
      (obj.infantCount = Math.round(message.infantCount));
    message.amount !== undefined && (obj.amount = message.amount);
    message.discountInformation !== undefined &&
      (obj.discountInformation = message.discountInformation
        ? DiscountInformation.toJSON(message.discountInformation)
        : undefined);
    if (message.roomPriceList) {
      obj.roomPriceList = message.roomPriceList.map((e) =>
        e ? RoomPrice.toJSON(e) : undefined
      );
    } else {
      obj.roomPriceList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<PackagePrice>): PackagePrice {
    const message = createBasePackagePrice();
    message.adultCount = object.adultCount ?? 0;
    message.childCount = object.childCount ?? 0;
    message.infantCount = object.infantCount ?? 0;
    message.amount = object.amount ?? 0;
    message.discountInformation =
      object.discountInformation !== undefined &&
      object.discountInformation !== null
        ? DiscountInformation.fromPartial(object.discountInformation)
        : undefined;
    message.roomPriceList =
      object.roomPriceList?.map((e) => RoomPrice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTourOperatorVoucherComponent(): TourOperatorVoucherComponent {
  return {
    amount: 0,
    tourOperator: "",
    description: "",
    validUntil: "",
    redeemType: RedeemType.RedeemTypeUnknown,
  };
}

export const TourOperatorVoucherComponent = {
  encode(
    message: TourOperatorVoucherComponent,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.tourOperator !== "") {
      writer.uint32(18).string(message.tourOperator);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.validUntil !== "") {
      writer.uint32(34).string(message.validUntil);
    }
    if (message.redeemType !== RedeemType.RedeemTypeUnknown) {
      writer.uint32(40).int32(redeemTypeToNumber(message.redeemType));
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorVoucherComponent {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorVoucherComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.float();
          break;
        case 2:
          message.tourOperator = reader.string();
          break;
        case 3:
          message.description = reader.string();
          break;
        case 4:
          message.validUntil = reader.string();
          break;
        case 5:
          message.redeemType = redeemTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorVoucherComponent {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      tourOperator: isSet(object.tourOperator)
        ? String(object.tourOperator)
        : "",
      description: isSet(object.description) ? String(object.description) : "",
      validUntil: isSet(object.validUntil) ? String(object.validUntil) : "",
      redeemType: isSet(object.redeemType)
        ? redeemTypeFromJSON(object.redeemType)
        : RedeemType.RedeemTypeUnknown,
    };
  },

  toJSON(message: TourOperatorVoucherComponent): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = message.amount);
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator);
    message.description !== undefined &&
      (obj.description = message.description);
    message.validUntil !== undefined && (obj.validUntil = message.validUntil);
    message.redeemType !== undefined &&
      (obj.redeemType = redeemTypeToJSON(message.redeemType));
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorVoucherComponent>
  ): TourOperatorVoucherComponent {
    const message = createBaseTourOperatorVoucherComponent();
    message.amount = object.amount ?? 0;
    message.tourOperator = object.tourOperator ?? "";
    message.description = object.description ?? "";
    message.validUntil = object.validUntil ?? "";
    message.redeemType = object.redeemType ?? RedeemType.RedeemTypeUnknown;
    return message;
  },
};

function createBaseTravelPrice(): TravelPrice {
  return {
    amount: 0,
    ancillariesPrice: 0,
    refundableCancellationFee: 0,
    packagePrice: undefined,
    tourOperatorVoucher: undefined,
  };
}

export const TravelPrice = {
  encode(
    message: TravelPrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.ancillariesPrice !== 0) {
      writer.uint32(37).float(message.ancillariesPrice);
    }
    if (message.refundableCancellationFee !== 0) {
      writer.uint32(45).float(message.refundableCancellationFee);
    }
    if (message.packagePrice !== undefined) {
      PackagePrice.encode(
        message.packagePrice,
        writer.uint32(50).fork()
      ).ldelim();
    }
    if (message.tourOperatorVoucher !== undefined) {
      TourOperatorVoucherComponent.encode(
        message.tourOperatorVoucher,
        writer.uint32(26).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TravelPrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTravelPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.float();
          break;
        case 4:
          message.ancillariesPrice = reader.float();
          break;
        case 5:
          message.refundableCancellationFee = reader.float();
          break;
        case 6:
          message.packagePrice = PackagePrice.decode(reader, reader.uint32());
          break;
        case 3:
          message.tourOperatorVoucher = TourOperatorVoucherComponent.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TravelPrice {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      ancillariesPrice: isSet(object.ancillariesPrice)
        ? Number(object.ancillariesPrice)
        : 0,
      refundableCancellationFee: isSet(object.refundableCancellationFee)
        ? Number(object.refundableCancellationFee)
        : 0,
      packagePrice: isSet(object.packagePrice)
        ? PackagePrice.fromJSON(object.packagePrice)
        : undefined,
      tourOperatorVoucher: isSet(object.tourOperatorVoucher)
        ? TourOperatorVoucherComponent.fromJSON(object.tourOperatorVoucher)
        : undefined,
    };
  },

  toJSON(message: TravelPrice): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = message.amount);
    message.ancillariesPrice !== undefined &&
      (obj.ancillariesPrice = message.ancillariesPrice);
    message.refundableCancellationFee !== undefined &&
      (obj.refundableCancellationFee = message.refundableCancellationFee);
    message.packagePrice !== undefined &&
      (obj.packagePrice = message.packagePrice
        ? PackagePrice.toJSON(message.packagePrice)
        : undefined);
    message.tourOperatorVoucher !== undefined &&
      (obj.tourOperatorVoucher = message.tourOperatorVoucher
        ? TourOperatorVoucherComponent.toJSON(message.tourOperatorVoucher)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TravelPrice>): TravelPrice {
    const message = createBaseTravelPrice();
    message.amount = object.amount ?? 0;
    message.ancillariesPrice = object.ancillariesPrice ?? 0;
    message.refundableCancellationFee = object.refundableCancellationFee ?? 0;
    message.packagePrice =
      object.packagePrice !== undefined && object.packagePrice !== null
        ? PackagePrice.fromPartial(object.packagePrice)
        : undefined;
    message.tourOperatorVoucher =
      object.tourOperatorVoucher !== undefined &&
      object.tourOperatorVoucher !== null
        ? TourOperatorVoucherComponent.fromPartial(object.tourOperatorVoucher)
        : undefined;
    return message;
  },
};

function createBaseTotalPrice(): TotalPrice {
  return {
    amount: 0,
    perPerson: 0,
    notRefundableCancellationFee: 0,
    insurancePrice: 0,
    transferPrice: 0,
    travelPrice: undefined,
  };
}

export const TotalPrice = {
  encode(
    message: TotalPrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.perPerson !== 0) {
      writer.uint32(53).float(message.perPerson);
    }
    if (message.notRefundableCancellationFee !== 0) {
      writer.uint32(29).float(message.notRefundableCancellationFee);
    }
    if (message.insurancePrice !== 0) {
      writer.uint32(37).float(message.insurancePrice);
    }
    if (message.transferPrice !== 0) {
      writer.uint32(45).float(message.transferPrice);
    }
    if (message.travelPrice !== undefined) {
      TravelPrice.encode(
        message.travelPrice,
        writer.uint32(18).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TotalPrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTotalPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.float();
          break;
        case 6:
          message.perPerson = reader.float();
          break;
        case 3:
          message.notRefundableCancellationFee = reader.float();
          break;
        case 4:
          message.insurancePrice = reader.float();
          break;
        case 5:
          message.transferPrice = reader.float();
          break;
        case 2:
          message.travelPrice = TravelPrice.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TotalPrice {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      perPerson: isSet(object.perPerson) ? Number(object.perPerson) : 0,
      notRefundableCancellationFee: isSet(object.notRefundableCancellationFee)
        ? Number(object.notRefundableCancellationFee)
        : 0,
      insurancePrice: isSet(object.insurancePrice)
        ? Number(object.insurancePrice)
        : 0,
      transferPrice: isSet(object.transferPrice)
        ? Number(object.transferPrice)
        : 0,
      travelPrice: isSet(object.travelPrice)
        ? TravelPrice.fromJSON(object.travelPrice)
        : undefined,
    };
  },

  toJSON(message: TotalPrice): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = message.amount);
    message.perPerson !== undefined && (obj.perPerson = message.perPerson);
    message.notRefundableCancellationFee !== undefined &&
      (obj.notRefundableCancellationFee = message.notRefundableCancellationFee);
    message.insurancePrice !== undefined &&
      (obj.insurancePrice = message.insurancePrice);
    message.transferPrice !== undefined &&
      (obj.transferPrice = message.transferPrice);
    message.travelPrice !== undefined &&
      (obj.travelPrice = message.travelPrice
        ? TravelPrice.toJSON(message.travelPrice)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TotalPrice>): TotalPrice {
    const message = createBaseTotalPrice();
    message.amount = object.amount ?? 0;
    message.perPerson = object.perPerson ?? 0;
    message.notRefundableCancellationFee =
      object.notRefundableCancellationFee ?? 0;
    message.insurancePrice = object.insurancePrice ?? 0;
    message.transferPrice = object.transferPrice ?? 0;
    message.travelPrice =
      object.travelPrice !== undefined && object.travelPrice !== null
        ? TravelPrice.fromPartial(object.travelPrice)
        : undefined;
    return message;
  },
};

function createBaseCompensationVoucherComponent(): CompensationVoucherComponent {
  return { count: 0, amount: 0, tourOperator: "" };
}

export const CompensationVoucherComponent = {
  encode(
    message: CompensationVoucherComponent,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.tourOperator !== "") {
      writer.uint32(26).string(message.tourOperator);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): CompensationVoucherComponent {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompensationVoucherComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.count = reader.uint32();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 3:
          message.tourOperator = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CompensationVoucherComponent {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      tourOperator: isSet(object.tourOperator)
        ? String(object.tourOperator)
        : "",
    };
  },

  toJSON(message: CompensationVoucherComponent): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.amount !== undefined && (obj.amount = message.amount);
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator);
    return obj;
  },

  fromPartial(
    object: DeepPartial<CompensationVoucherComponent>
  ): CompensationVoucherComponent {
    const message = createBaseCompensationVoucherComponent();
    message.count = object.count ?? 0;
    message.amount = object.amount ?? 0;
    message.tourOperator = object.tourOperator ?? "";
    return message;
  },
};

function createBaseUnknownVoucherComponent(): UnknownVoucherComponent {
  return { count: 0, tourOperator: "" };
}

export const UnknownVoucherComponent = {
  encode(
    message: UnknownVoucherComponent,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).uint32(message.count);
    }
    if (message.tourOperator !== "") {
      writer.uint32(18).string(message.tourOperator);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): UnknownVoucherComponent {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnknownVoucherComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.uint32();
          break;
        case 2:
          message.tourOperator = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UnknownVoucherComponent {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      tourOperator: isSet(object.tourOperator)
        ? String(object.tourOperator)
        : "",
    };
  },

  toJSON(message: UnknownVoucherComponent): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.tourOperator !== undefined &&
      (obj.tourOperator = message.tourOperator);
    return obj;
  },

  fromPartial(
    object: DeepPartial<UnknownVoucherComponent>
  ): UnknownVoucherComponent {
    const message = createBaseUnknownVoucherComponent();
    message.count = object.count ?? 0;
    message.tourOperator = object.tourOperator ?? "";
    return message;
  },
};

function createBasePaidPrice(): PaidPrice {
  return {
    amount: 0,
    totalPrice: undefined,
    compensationVoucher: undefined,
    unknownVoucher: undefined,
  };
}

export const PaidPrice = {
  encode(
    message: PaidPrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.totalPrice !== undefined) {
      TotalPrice.encode(message.totalPrice, writer.uint32(18).fork()).ldelim();
    }
    if (message.compensationVoucher !== undefined) {
      CompensationVoucherComponent.encode(
        message.compensationVoucher,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.unknownVoucher !== undefined) {
      UnknownVoucherComponent.encode(
        message.unknownVoucher,
        writer.uint32(34).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaidPrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaidPrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.float();
          break;
        case 2:
          message.totalPrice = TotalPrice.decode(reader, reader.uint32());
          break;
        case 3:
          message.compensationVoucher = CompensationVoucherComponent.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.unknownVoucher = UnknownVoucherComponent.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PaidPrice {
    return {
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      totalPrice: isSet(object.totalPrice)
        ? TotalPrice.fromJSON(object.totalPrice)
        : undefined,
      compensationVoucher: isSet(object.compensationVoucher)
        ? CompensationVoucherComponent.fromJSON(object.compensationVoucher)
        : undefined,
      unknownVoucher: isSet(object.unknownVoucher)
        ? UnknownVoucherComponent.fromJSON(object.unknownVoucher)
        : undefined,
    };
  },

  toJSON(message: PaidPrice): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = message.amount);
    message.totalPrice !== undefined &&
      (obj.totalPrice = message.totalPrice
        ? TotalPrice.toJSON(message.totalPrice)
        : undefined);
    message.compensationVoucher !== undefined &&
      (obj.compensationVoucher = message.compensationVoucher
        ? CompensationVoucherComponent.toJSON(message.compensationVoucher)
        : undefined);
    message.unknownVoucher !== undefined &&
      (obj.unknownVoucher = message.unknownVoucher
        ? UnknownVoucherComponent.toJSON(message.unknownVoucher)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<PaidPrice>): PaidPrice {
    const message = createBasePaidPrice();
    message.amount = object.amount ?? 0;
    message.totalPrice =
      object.totalPrice !== undefined && object.totalPrice !== null
        ? TotalPrice.fromPartial(object.totalPrice)
        : undefined;
    message.compensationVoucher =
      object.compensationVoucher !== undefined &&
      object.compensationVoucher !== null
        ? CompensationVoucherComponent.fromPartial(object.compensationVoucher)
        : undefined;
    message.unknownVoucher =
      object.unknownVoucher !== undefined && object.unknownVoucher !== null
        ? UnknownVoucherComponent.fromPartial(object.unknownVoucher)
        : undefined;
    return message;
  },
};

function createBaseC24VoucherComponent(): C24VoucherComponent {
  return {
    isWebsitePromo: false,
    amount: 0,
    type: VoucherType.VoucherTypeUnknown,
  };
}

export const C24VoucherComponent = {
  encode(
    message: C24VoucherComponent,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isWebsitePromo === true) {
      writer.uint32(24).bool(message.isWebsitePromo);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.type !== VoucherType.VoucherTypeUnknown) {
      writer.uint32(16).int32(voucherTypeToNumber(message.type));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): C24VoucherComponent {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseC24VoucherComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.isWebsitePromo = reader.bool();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 2:
          message.type = voucherTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): C24VoucherComponent {
    return {
      isWebsitePromo: isSet(object.isWebsitePromo)
        ? Boolean(object.isWebsitePromo)
        : false,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      type: isSet(object.type)
        ? voucherTypeFromJSON(object.type)
        : VoucherType.VoucherTypeUnknown,
    };
  },

  toJSON(message: C24VoucherComponent): unknown {
    const obj: any = {};
    message.isWebsitePromo !== undefined &&
      (obj.isWebsitePromo = message.isWebsitePromo);
    message.amount !== undefined && (obj.amount = message.amount);
    message.type !== undefined && (obj.type = voucherTypeToJSON(message.type));
    return obj;
  },

  fromPartial(object: DeepPartial<C24VoucherComponent>): C24VoucherComponent {
    const message = createBaseC24VoucherComponent();
    message.isWebsitePromo = object.isWebsitePromo ?? false;
    message.amount = object.amount ?? 0;
    message.type = object.type ?? VoucherType.VoucherTypeUnknown;
    return message;
  },
};

function createBaseLoyaltyPointsCashback(): LoyaltyPointsCashback {
  return { isRelevant: false, redeemablePoints: 0, amount: 0 };
}

export const LoyaltyPointsCashback = {
  encode(
    message: LoyaltyPointsCashback,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isRelevant === true) {
      writer.uint32(8).bool(message.isRelevant);
    }
    if (message.redeemablePoints !== 0) {
      writer.uint32(16).uint32(message.redeemablePoints);
    }
    if (message.amount !== 0) {
      writer.uint32(29).float(message.amount);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): LoyaltyPointsCashback {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoyaltyPointsCashback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isRelevant = reader.bool();
          break;
        case 2:
          message.redeemablePoints = reader.uint32();
          break;
        case 3:
          message.amount = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LoyaltyPointsCashback {
    return {
      isRelevant: isSet(object.isRelevant) ? Boolean(object.isRelevant) : false,
      redeemablePoints: isSet(object.redeemablePoints)
        ? Number(object.redeemablePoints)
        : 0,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
    };
  },

  toJSON(message: LoyaltyPointsCashback): unknown {
    const obj: any = {};
    message.isRelevant !== undefined && (obj.isRelevant = message.isRelevant);
    message.redeemablePoints !== undefined &&
      (obj.redeemablePoints = Math.round(message.redeemablePoints));
    message.amount !== undefined && (obj.amount = message.amount);
    return obj;
  },

  fromPartial(
    object: DeepPartial<LoyaltyPointsCashback>
  ): LoyaltyPointsCashback {
    const message = createBaseLoyaltyPointsCashback();
    message.isRelevant = object.isRelevant ?? false;
    message.redeemablePoints = object.redeemablePoints ?? 0;
    message.amount = object.amount ?? 0;
    return message;
  },
};

function createBaseEffectivePrice(): EffectivePrice {
  return {
    showEffectivePrice: false,
    hasAmountDiff: false,
    amount: 0,
    cashback: 0,
    cashbackType: EffectivePrice_CashbackType.None,
    paidPrice: undefined,
    c24Voucher: undefined,
    tourOperatorVoucher: undefined,
    loyaltyPointsCashback: undefined,
  };
}

export const EffectivePrice = {
  encode(
    message: EffectivePrice,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.showEffectivePrice === true) {
      writer.uint32(56).bool(message.showEffectivePrice);
    }
    if (message.hasAmountDiff === true) {
      writer.uint32(32).bool(message.hasAmountDiff);
    }
    if (message.amount !== 0) {
      writer.uint32(13).float(message.amount);
    }
    if (message.cashback !== 0) {
      writer.uint32(69).float(message.cashback);
    }
    if (message.cashbackType !== EffectivePrice_CashbackType.None) {
      writer
        .uint32(72)
        .int32(effectivePrice_CashbackTypeToNumber(message.cashbackType));
    }
    if (message.paidPrice !== undefined) {
      PaidPrice.encode(message.paidPrice, writer.uint32(18).fork()).ldelim();
    }
    if (message.c24Voucher !== undefined) {
      C24VoucherComponent.encode(
        message.c24Voucher,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.tourOperatorVoucher !== undefined) {
      TourOperatorVoucherComponent.encode(
        message.tourOperatorVoucher,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.loyaltyPointsCashback !== undefined) {
      LoyaltyPointsCashback.encode(
        message.loyaltyPointsCashback,
        writer.uint32(50).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EffectivePrice {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEffectivePrice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7:
          message.showEffectivePrice = reader.bool();
          break;
        case 4:
          message.hasAmountDiff = reader.bool();
          break;
        case 1:
          message.amount = reader.float();
          break;
        case 8:
          message.cashback = reader.float();
          break;
        case 9:
          message.cashbackType = effectivePrice_CashbackTypeFromJSON(
            reader.int32()
          );
          break;
        case 2:
          message.paidPrice = PaidPrice.decode(reader, reader.uint32());
          break;
        case 3:
          message.c24Voucher = C24VoucherComponent.decode(
            reader,
            reader.uint32()
          );
          break;
        case 5:
          message.tourOperatorVoucher = TourOperatorVoucherComponent.decode(
            reader,
            reader.uint32()
          );
          break;
        case 6:
          message.loyaltyPointsCashback = LoyaltyPointsCashback.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): EffectivePrice {
    return {
      showEffectivePrice: isSet(object.showEffectivePrice)
        ? Boolean(object.showEffectivePrice)
        : false,
      hasAmountDiff: isSet(object.hasAmountDiff)
        ? Boolean(object.hasAmountDiff)
        : false,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      cashback: isSet(object.cashback) ? Number(object.cashback) : 0,
      cashbackType: isSet(object.cashbackType)
        ? effectivePrice_CashbackTypeFromJSON(object.cashbackType)
        : EffectivePrice_CashbackType.None,
      paidPrice: isSet(object.paidPrice)
        ? PaidPrice.fromJSON(object.paidPrice)
        : undefined,
      c24Voucher: isSet(object.c24Voucher)
        ? C24VoucherComponent.fromJSON(object.c24Voucher)
        : undefined,
      tourOperatorVoucher: isSet(object.tourOperatorVoucher)
        ? TourOperatorVoucherComponent.fromJSON(object.tourOperatorVoucher)
        : undefined,
      loyaltyPointsCashback: isSet(object.loyaltyPointsCashback)
        ? LoyaltyPointsCashback.fromJSON(object.loyaltyPointsCashback)
        : undefined,
    };
  },

  toJSON(message: EffectivePrice): unknown {
    const obj: any = {};
    message.showEffectivePrice !== undefined &&
      (obj.showEffectivePrice = message.showEffectivePrice);
    message.hasAmountDiff !== undefined &&
      (obj.hasAmountDiff = message.hasAmountDiff);
    message.amount !== undefined && (obj.amount = message.amount);
    message.cashback !== undefined && (obj.cashback = message.cashback);
    message.cashbackType !== undefined &&
      (obj.cashbackType = effectivePrice_CashbackTypeToJSON(
        message.cashbackType
      ));
    message.paidPrice !== undefined &&
      (obj.paidPrice = message.paidPrice
        ? PaidPrice.toJSON(message.paidPrice)
        : undefined);
    message.c24Voucher !== undefined &&
      (obj.c24Voucher = message.c24Voucher
        ? C24VoucherComponent.toJSON(message.c24Voucher)
        : undefined);
    message.tourOperatorVoucher !== undefined &&
      (obj.tourOperatorVoucher = message.tourOperatorVoucher
        ? TourOperatorVoucherComponent.toJSON(message.tourOperatorVoucher)
        : undefined);
    message.loyaltyPointsCashback !== undefined &&
      (obj.loyaltyPointsCashback = message.loyaltyPointsCashback
        ? LoyaltyPointsCashback.toJSON(message.loyaltyPointsCashback)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<EffectivePrice>): EffectivePrice {
    const message = createBaseEffectivePrice();
    message.showEffectivePrice = object.showEffectivePrice ?? false;
    message.hasAmountDiff = object.hasAmountDiff ?? false;
    message.amount = object.amount ?? 0;
    message.cashback = object.cashback ?? 0;
    message.cashbackType =
      object.cashbackType ?? EffectivePrice_CashbackType.None;
    message.paidPrice =
      object.paidPrice !== undefined && object.paidPrice !== null
        ? PaidPrice.fromPartial(object.paidPrice)
        : undefined;
    message.c24Voucher =
      object.c24Voucher !== undefined && object.c24Voucher !== null
        ? C24VoucherComponent.fromPartial(object.c24Voucher)
        : undefined;
    message.tourOperatorVoucher =
      object.tourOperatorVoucher !== undefined &&
      object.tourOperatorVoucher !== null
        ? TourOperatorVoucherComponent.fromPartial(object.tourOperatorVoucher)
        : undefined;
    message.loyaltyPointsCashback =
      object.loyaltyPointsCashback !== undefined &&
      object.loyaltyPointsCashback !== null
        ? LoyaltyPointsCashback.fromPartial(object.loyaltyPointsCashback)
        : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
